import styled from "styled-components";

export const AboutConatiner = styled.div`
    flex-direction: column;
    justify-content: center;
    width: 98.8vw;
    min-height: #0A0204;
    padding: 5rem calc((100vw-1300px) /2);
    background: #150308;
    color : #fff;

    p {
        font-size: clamp(1rem, 2vw, 2rem);
        text-align: center;
    }
`

export const AboutH1 = styled.h1`
    font-size: clamp(1.5rem, 1vw, 5rem);
    margin-bottom: 0 auto;
    letter-spacing: 3px;
    text-align : center;
`

export const AboutImage = styled.img`
    display: block;
    margin-left: auto;
    margin-right: auto;
    margin-top: 3rem;
    height: 300px;
    width: 335px;
    max-width: 100%;
    box-shadow: 7px 2px #fdc500;
    border-radius: 50%;
   
`

export const AboutContaineer = styled.div`
    width: 98.8vw;
    min-height: #0A0204;
    padding: 5rem calc((100vw-1300px) /2);
    background: #150308;
    color : #fff;
`